export default __webpack_public_path__ + "static/media/illus-escalier-red.346aa44d.svg";